/**
 * Shared CSV helpers for bulk-import templates and admin data export.
 * RFC 4180-lite: quote when the value contains a comma, quote, or newline.
 */

export function csvEscape(value: string): string {
    if (value === "") return "";
    if (value.includes(",") || value.includes('"') || value.includes("\n")) {
        return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
}

export function buildCsv(headers: readonly string[], rows: readonly (readonly string[])[]): string {
    const lines = [
        headers.join(","),
        ...rows.map((cells) => cells.map((c) => csvEscape(c)).join(",")),
    ];
    return lines.join("\n") + "\n";
}

export function csvDateStamp(date: Date = new Date()): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}

/**
 * Browser-side download trigger. Build a Blob, create an object URL,
 * click a synthetic anchor, then revoke the URL on the next tick to
 * avoid GC-holding the blob.
 */
export function triggerCsvDownload(filename: string, contents: string): void {
    const blob = new Blob([contents], { type: "text/csv;charset=utf-8" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    setTimeout(() => URL.revokeObjectURL(url), 0);
}
